import { Backdrop } from "@mui/material";
import Lottie from "lottie-react";
import loaderAnimation from "../../assets/loader.json";
import { useLoading } from "../../hooks/useLoadingContext";

const LoadingSpinner = () => {
    const { isLoading } = useLoading();

    return (
        <Backdrop
            sx={{
                position: 'fixed',
                zIndex: (theme) => theme.zIndex.modal + 1,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
            open={isLoading}
        >
            <div style={{ width: 200, height: 200 }}>
                <Lottie animationData={loaderAnimation} loop autoplay />
            </div>
        </Backdrop>
    );
};

export default LoadingSpinner;
